import { createLayerCanvas, drawCircle, toDataUrl } from './canvasUtils'
import { extractLandmarkFeatures } from './extractLandmarkFeatures'

export const buildPupilLayer = ({ landmarks, width, height, features = null }) => {
  if (!landmarks?.length) return null
  const featureMap = features || extractLandmarkFeatures({ landmarks, width, height })
  const leftPupil = featureMap?.pupils?.left || null
  const rightPupil = featureMap?.pupils?.right || null
  const radius = featureMap?.pupils?.radius || Math.min(width, height) * 0.04
  if (!leftPupil && !rightPupil) return null
  const { canvas, ctx } = createLayerCanvas(width, height)

  if (leftPupil?.center) {
    drawCircle(
      ctx,
      leftPupil.center.x,
      leftPupil.center.y,
      leftPupil.radius || radius,
      'rgba(15, 23, 42, 0.95)'
    )
  }
  if (rightPupil?.center) {
    drawCircle(
      ctx,
      rightPupil.center.x,
      rightPupil.center.y,
      rightPupil.radius || radius,
      'rgba(15, 23, 42, 0.95)'
    )
  }
  return toDataUrl(canvas)
}
